export function calculteEMI(loanAmount, interestRate, loanTenureMonths) {
  if (!loanAmount || !interestRate || !loanTenureMonths) return;

  // Convert annual interest rate to monthly rate and percentage to decimal
  const monthlyInterestRate = interestRate / 12 / 100;

  let emi;
  // Calculate EMI
  const numerator =
    loanAmount *
    monthlyInterestRate *
    Math.pow(1 + monthlyInterestRate, loanTenureMonths);
  const denominator = Math.pow(1 + monthlyInterestRate, loanTenureMonths) - 1;
  emi = numerator / denominator;

  return Math.ceil(emi);
}

export function calculateEMIWithLoanAmount(
  loanAmount,
  interestRate,
  loanTenureMonths,
  FOIR_Limit,
  loanDecreasingStep,
  monthlyObligations,
  monthlyIncome
) {
  // if (
  //   !loanAmount ||
  //   !interestRate ||
  //   !loanTenureMonths ||
  //   !loanDecreasingStep ||
  //   monthlyObligations !== null ||
  //   !monthlyIncome
  // )
  //   return;

  let emi,
    maxLoanAmount = loanAmount;

  // Loop until get the best loan amount that FOIR doesn't exceed the FOIR limit
  do {
    // Calculate EMI
    emi = calculteEMI(maxLoanAmount, interestRate, loanTenureMonths);

    // Calculate new FOIR after adding new EMI in already running EMIs
    let NewCustomerFOIR = Math.ceil(
      ((monthlyObligations + emi) * 100) / monthlyIncome
    );

    // New FOIT Limit is less than or equal to FOIR limit then break
    if (NewCustomerFOIR <= FOIR_Limit) break;

    // Decrease the loan amount if customer's latest FOIR is exceeding the FOIR limit
    maxLoanAmount = maxLoanAmount - loanDecreasingStep;
  } while (true);

  return { emi: emi, maxLoanAmount: maxLoanAmount };
}

// * Function to create the form data (Used in Add Course , Edit Course APIs)
export function multiPartData(data, type = "") {
  let multiPart = new FormData();
  for (let key in data) {
    if (type === "multiple" && key === "blogImage") {
      data[key].forEach((file) => {
        multiPart.append(key, file);
      });
    } else if (key !== "blogImage") {
      multiPart.append(key, data[key]);
    }
  }

  return multiPart;
}

export const CRIF_Dataa = {
  "B2C-REPORT": {
    HEADER: {
      "DATE-OF-REQUEST": "02-08-2023",
      "PREPARED-FOR": "  ",
      "PREPARED-FOR-ID": "SUJ0000001",
      "DATE-OF-ISSUE": "02-08-2023",
      "REPORT-ID": "CCR230802CR699303035",
      "BATCH-ID": "2244766662230802",
      STATUS: "SUCCESS",
    },
    REQUEST: {
      NAME: "abhishek verma",
      DOB: "28-03-1999",
      PAN: "BMKPV4066L",
      "EMAIL-1": "jackabhi99@gmail.com",
      "ADDRESS-1":
        "a180 st no 4, west vinod nagar East Delhi East Delhi 110092 DELHI",
      "ADDRESS-2": "",
      "ADDRESS-3": "",
      "PHONE-1": "9999599523",
    },
    "PERSONAL-INFO-VARIATION": {
      "NAME-VARIATIONS": [
        {
          VARIATION: {
            VALUE: "ABHISHEK  VERMA",
            "REPORTED-DATE": "31-08-2021",
          },
        },
      ],
      "ADDRESS-VARIATIONS": [
        {
          VARIATION: {
            VALUE:
              "HOUSE NO-A-180, STREET NO-4 WEST VINOD NAGAR, MANDAWALI  NEWDELHI 110092 DL",
            "REPORTED-DATE": "31-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "S/O RAVINDER KUMAR VERMA H NO A-180 NEW DELHI 110092 DL",
            "REPORTED-DATE": "08-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "A-180 STREET NO 4WEST VINOD NAGAR DELHI 110092 DL",
            "REPORTED-DATE": "31-08-2021",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NO-A-180 STREET NO-4 WEST VINOD NAGAR MANDAWALI S/O RAVINDER KUMAR VERMA NEW DELHI 110092 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "SAI KRIPA A180 ST. NO. 4 WEST VINOD NAGAR  DELHI 110092 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NO-A-180,  STREET NO-4,  W EST VINOD NAGAR  MANDAWALI NEWDELHI 110092 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NOA180STREET NO4WEST VINOD NA GAREAST DELHIMANDAWALINULL EAST DELHI 110092 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NO-A-180 STREET NO-4 WEST VINOD NAGAR MANDAWALI 110092 DL",
            "REPORTED-DATE": "31-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "S/O RAVINDER KUMAR VERMA, HOUSE NO-A-180 STREET NO-4 MANDAWALI DELHI 110092 110092 DL",
            "REPORTED-DATE": "31-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "FIRST FLOOR BUILDING NO 5A LANE NO 1 WESTEND 110030 DL",
            "REPORTED-DATE": "31-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NO A 180 STREET NO 4 WEST VINOD NAGAR MANDAWALI EAST DELHI DELHI   DELHI DELHI 110092 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "S O RAVINDER KUMAR VERMA HOUSE NO A 180 STREET NO 4 NEW DELHI 110092 110092 DL",
            "REPORTED-DATE": "30-11-2022",
          },
        },
        {
          VARIATION: {
            VALUE:
              "KIMAYA MEDICAL SOLUTION PV BUILDING NO 5A LANE NO-1 1ST FLOOR WESTAND MARG SAI DULALJAB DELHI NEW DELHI 110030 DL",
            "REPORTED-DATE": "09-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "A 180 STREET NO. 9 WEST VINOD NAGAR DELHI NEW DELHI 110092 DL",
            "REPORTED-DATE": "09-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "S/O RAVINDER KUMAR VERMA HOUSE NO-A-180 STREET NO-4 WEST VINOD NAGAR MANPAWALI DELHI 110092 110092 DL",
            "REPORTED-DATE": "31-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "HOUSE NO A 180 STREET NO 4 WEST VINOD NA MANDAWALI EAST DELHI LOS EAST DELHI, DELHI 110092 DL",
            "REPORTED-DATE": "15-02-2023",
          },
        },
        {
          VARIATION: {
            VALUE:
              "FIRST FLOOR BUILDING NO.5A LANE NO.1 WESTEND  DELHI 110030 DL",
            "REPORTED-DATE": "30-06-2023",
          },
        },
      ],
      "PAN-VARIATIONS": [
        {
          VARIATION: {
            VALUE: "BMKPV4066L",
            "REPORTED-DATE": "31-08-2021",
          },
        },
      ],
      "UID-VARIATIONS": [],
      "OTHER-ID-VARIATIONS": [],
      "DRIVING-LICENSE-VARIATIONS": [],
      "DATE-OF-BIRTH-VARIATIONS": [
        {
          VARIATION: {
            VALUE: "28-03-1999",
            "REPORTED-DATE": "31-08-2021",
          },
        },
      ],
      "VOTER-ID-VARIATIONS": [],
      "PASSPORT-VARIATIONS": [],
      "PHONE-NUMBER-VARIATIONS": [
        {
          VARIATION: {
            VALUE: "0119999599523",
            "REPORTED-DATE": "09-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "9999599523",
            "REPORTED-DATE": "31-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "9971765457",
            "REPORTED-DATE": "31-08-2021",
          },
        },
        {
          VARIATION: {
            VALUE: "09999599523",
            "REPORTED-DATE": "09-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "00919999599523",
            "REPORTED-DATE": "31-07-2023",
          },
        },
      ],
      "RATION-CARD-VARIATIONS": [],
      "EMAIL-VARIATIONS": [
        {
          VARIATION: {
            VALUE: "text@gmail.com",
            "REPORTED-DATE": "16-05-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "JACKABHI99@GMAIL.COM",
            "REPORTED-DATE": "31-07-2023",
          },
        },
        {
          VARIATION: {
            VALUE: "abhishek.verma@medphine.com",
            "REPORTED-DATE": "31-05-2023",
          },
        },
      ],
    },
    "SECONDARY-MATCHES": [],
    "ACCOUNTS-SUMMARY": {
      "DERIVED-ATTRIBUTES": {
        "INQURIES-IN-LAST-SIX-MONTHS": 3,
        "LENGTH-OF-CREDIT-HISTORY-YEAR": 1,
        "LENGTH-OF-CREDIT-HISTORY-MONTH": 8,
        "AVERAGE-ACCOUNT-AGE-YEAR": 0,
        "AVERAGE-ACCOUNT-AGE-MONTH": 8,
        "NEW-ACCOUNTS-IN-LAST-SIX-MONTHS": 1,
        "NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS": 0,
      },
      "PRIMARY-ACCOUNTS-SUMMARY": {
        "PRIMARY-NUMBER-OF-ACCOUNTS": 12,
        "PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS": 6,
        "PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS": 0,
        "PRIMARY-SECURED-NUMBER-OF-ACCOUNTS": 0,
        "PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS": 12,
        "PRIMARY-UNTAGGED-NUMBER-OF-ACCOUNTS": 0,
        "PRIMARY-CURRENT-BALANCE": "6,83,017",
        "PRIMARY-SANCTIONED-AMOUNT": "7,76,846",
        "PRIMARY-DISBURSED-AMOUNT": "7,76,846",
      },
      "SECONDARY-ACCOUNTS-SUMMARY": {
        "SECONDARY-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-ACTIVE-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-OVERDUE-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-SECURED-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-UNSECURED-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-UNTAGGED-NUMBER-OF-ACCOUNTS": 0,
        "SECONDARY-CURRENT-BALANCE": "0",
        "SECONDARY-SANCTIONED-AMOUNT": "0",
        "SECONDARY-DISBURSED-AMOUNT": "0",
      },
    },
    RESPONSES: [
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "SL4883508",
            "CREDIT-GUARANTOR": "INDIA INFOLINE FINANCE LIMITED",
            "ACCT-TYPE": "Personal Loan",
            "DATE-REPORTED": "30-06-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "50,000",
            "DISBURSED-DT": "20-06-2023",
            "INSTALLMENT-AMT": "5,023",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "50,000",
            "COMBINED-PAYMENT-HISTORY": "Jun:2023,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "WRITTEN-OFF_SETTLED-STATUS": "",
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "PLFLD024454",
            "CREDIT-GUARANTOR": "MUTHOOT FINANCE LIMITED",
            "ACCT-TYPE": "Personal Loan",
            "DATE-REPORTED": "16-05-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "2,25,000",
            "DISBURSED-DT": "15-11-2022",
            "LAST-PAYMENT-DATE": "10-05-2023",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "1,94,849",
            "COMBINED-PAYMENT-HISTORY":
              "May:2023,000/STD|Apr:2023,XXX/XXX|Mar:2023,XXX/XXX|Feb:2023,000/STD|Jan:2023,XXX/XXX|Dec:2022,000/STD|Nov:2022,000/STD|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "29182948",
            "CREDIT-GUARANTOR": "HDB FINANCIAL SERVICES LIMITED",
            "ACCT-TYPE": "Personal Loan",
            "DATE-REPORTED": "30-06-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "3,00,000",
            "DISBURSED-DT": "14-11-2022",
            "LAST-PAYMENT-DATE": "17-06-2023",
            "INSTALLMENT-AMT": "16,805/Monthly",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "2,40,859",
            "COMBINED-PAYMENT-HISTORY":
              "Jun:2023,000/XXX|May:2023,000/XXX|Apr:2023,000/XXX|Mar:2023,000/XXX|Feb:2023,000/XXX|Jan:2023,000/XXX|Dec:2022,000/XXX|Nov:2022,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "24",
            "ACTUAL-PAYMENT": "1",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "DELPPL00100010733972",
            "CREDIT-GUARANTOR": "HERO FINCORP LIMITED",
            "ACCT-TYPE": "Personal Loan",
            "DATE-REPORTED": "31-05-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "40,000",
            "DISBURSED-DT": "04-11-2022",
            "LAST-PAYMENT-DATE": "03-05-2023",
            "CLOSED-DATE": "05-05-2023",
            "INSTALLMENT-AMT": "7,384/Monthly",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY":
              "May:2023,000/STD|Apr:2023,000/STD|Mar:2023,000/STD|Feb:2023,000/STD|Jan:2023,000/STD|Dec:2022,000/STD|Nov:2022,000/STD|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "SUIT-FILED_WILFUL-DEFAULT": "No Suit filed",
            "REPAYMENT-TENURE": "6",
            "ACTUAL-PAYMENT": "44,304",
            "INTEREST-RATE": "36.0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "401ECFIT483494",
            "CREDIT-GUARANTOR": "BAJAJ FINANCE LIMITED",
            "ACCT-TYPE": "Consumer Loan",
            "DATE-REPORTED": "31-05-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "15,999",
            "DISBURSED-DT": "13-10-2022",
            "LAST-PAYMENT-DATE": "02-04-2023",
            "CLOSED-DATE": "04-04-2023",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY":
              "Apr:2023,000/XXX|Mar:2023,000/XXX|Feb:2023,000/XXX|Jan:2023,000/XXX|Dec:2022,000/XXX|Nov:2022,000/XXX|Oct:2022,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "0004611199677565775",
            "CREDIT-GUARANTOR": "SBI CARD",
            "ACCT-TYPE": "Credit Card",
            "DATE-REPORTED": "08-08-2022",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "0",
            "DISBURSED-DT": "20-05-2022",
            "CLOSED-DATE": "25-05-2022",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY": "May:2022,XXX/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "CREDIT-LIMIT": "20,000",
            "CASH-LIMIT": "2,000",
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "0004611199677565775",
            "CREDIT-GUARANTOR": "SBI CARD",
            "ACCT-TYPE": "Credit Card",
            "DATE-REPORTED": "09-07-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "0",
            "DISBURSED-DT": "20-05-2022",
            "CLOSED-DATE": "25-05-2022",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY": "May:2022,XXX/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "CREDIT-LIMIT": "20,000",
            "CASH-LIMIT": "2,000",
            "SECURITY-DETAILS": [],
            "WRITTEN-OFF_SETTLED-STATUS": "",
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "453440397",
            "CREDIT-GUARANTOR": "HDFC BANK LTD",
            "ACCT-TYPE": "Consumer Loan",
            "DATE-REPORTED": "31-05-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "52,461",
            "DISBURSED-DT": "20-05-2022",
            "LAST-PAYMENT-DATE": "05-05-2023",
            "CLOSED-DATE": "05-05-2023",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY":
              "May:2023,000/STD|Apr:2023,000/STD|Mar:2023,000/STD|Feb:2023,000/STD|Jan:2023,000/STD|Dec:2022,000/STD|Nov:2022,000/STD|Oct:2022,000/STD|Sep:2022,000/STD|Aug:2022,000/STD|Jul:2022,000/STD|Jun:2022,000/STD|May:2022,000/STD|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "4,786",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "9406151003523729",
            "CREDIT-GUARANTOR": "KOTAK MAHINDRA BANK",
            "ACCT-TYPE": "Credit Card",
            "DATE-REPORTED": "30-06-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "75,023",
            "DISBURSED-DT": "05-04-2022",
            "LAST-PAYMENT-DATE": "29-06-2023",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "73,296",
            "COMBINED-PAYMENT-HISTORY":
              "Jun:2023,000/XXX|May:2023,000/XXX|Apr:2023,000/XXX|Mar:2023,000/XXX|Feb:2023,000/XXX|Jan:2023,000/XXX|Dec:2022,000/XXX|Nov:2022,000/XXX|Oct:2022,000/XXX|Sep:2022,000/XXX|Aug:2022,000/XXX|Jul:2022,000/XXX|Jun:2022,000/XXX|May:2022,000/XXX|Apr:2022,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [
              {
                "ACCOUNT-DETAILS": {
                  "ACCT-NUMBER": "9406550008888369",
                  "CREDIT-GUARANTOR": "KOTAK MAHINDRA BANK",
                  "ACCT-TYPE": "Credit Card",
                  "DATE-REPORTED": "31-12-2022",
                  "OWNERSHIP-IND": "Individual",
                  "ACCOUNT-STATUS": "Active",
                  "DISBURSED-AMT": "70,043",
                  "DISBURSED-DT": "05-04-2022",
                  "LAST-PAYMENT-DATE": "29-12-2022",
                  "OVERDUE-AMT": "0",
                  "CURRENT-BAL": "70,043",
                  "CREDIT-LIMIT": "75,000",
                  "SECURITY-DETAILS": {
                    "SECURITY-DETAIL": {},
                  },
                },
              },
            ],
            "CREDIT-LIMIT": "75,000",
            "CASH-LIMIT": "15,000",
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "72,948",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "0004341550104819747",
            "CREDIT-GUARANTOR": "HDFC BANK LTD",
            "ACCT-TYPE": "Credit Card",
            "DATE-REPORTED": "30-06-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "1,09,216",
            "DISBURSED-DT": "17-12-2021",
            "LAST-PAYMENT-DATE": "07-06-2023",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "1,07,636",
            "COMBINED-PAYMENT-HISTORY":
              "Jun:2023,000/XXX|May:2023,000/XXX|Apr:2023,000/XXX|Mar:2023,000/XXX|Feb:2023,000/XXX|Jan:2023,000/XXX|Dec:2022,000/XXX|Nov:2022,000/XXX|Oct:2022,000/XXX|Sep:2022,000/XXX|Aug:2022,000/XXX|Jul:2022,000/XXX|Jun:2022,000/XXX|May:2022,000/XXX|Apr:2022,000/XXX|Mar:2022,000/XXX|Feb:2022,000/XXX|Jan:2022,000/XXX|Dec:2021,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [
              {
                "ACCOUNT-DETAILS": {
                  "ACCT-NUMBER": "0004632020012950149",
                  "CREDIT-GUARANTOR": "HDFC BANK LTD",
                  "ACCT-TYPE": "Credit Card",
                  "DATE-REPORTED": "30-11-2022",
                  "OWNERSHIP-IND": "Individual",
                  "ACCOUNT-STATUS": "Active",
                  "DISBURSED-AMT": "1,09,209",
                  "DISBURSED-DT": "17-12-2021",
                  "LAST-PAYMENT-DATE": "09-11-2022",
                  "CURRENT-BAL": "1,01,874",
                  "SECURITY-DETAILS": {
                    "SECURITY-DETAIL": {},
                  },
                },
              },
              {
                "ACCOUNT-DETAILS": {
                  "ACCT-NUMBER": "0004632020002007140",
                  "CREDIT-GUARANTOR": "HDFC BANK LTD",
                  "ACCT-TYPE": "Credit Card",
                  "DATE-REPORTED": "31-08-2022",
                  "OWNERSHIP-IND": "Individual",
                  "ACCOUNT-STATUS": "Active",
                  "DISBURSED-AMT": "1,08,587",
                  "DISBURSED-DT": "17-12-2021",
                  "LAST-PAYMENT-DATE": "26-08-2022",
                  "CURRENT-BAL": "49,725",
                  "SECURITY-DETAILS": {
                    "SECURITY-DETAIL": {},
                  },
                },
              },
            ],
            "CREDIT-LIMIT": "1,10,000",
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "0001006060000341475",
            "CREDIT-GUARANTOR": "YES BANK",
            "ACCT-TYPE": "Credit Card",
            "DATE-REPORTED": "31-07-2023",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Active",
            "DISBURSED-AMT": "17,607",
            "DISBURSED-DT": "18-11-2021",
            "LAST-PAYMENT-DATE": "21-07-2023",
            "INSTALLMENT-AMT": "0",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "16,377",
            "COMBINED-PAYMENT-HISTORY":
              "Jul:2023,000/XXX|Jun:2023,000/XXX|May:2023,000/XXX|Apr:2023,000/XXX|Mar:2023,000/XXX|Feb:2023,000/XXX|Jan:2023,000/XXX|Dec:2022,000/XXX|Nov:2022,000/XXX|Oct:2022,000/XXX|Sep:2022,000/XXX|Aug:2022,000/XXX|Jul:2022,000/XXX|Jun:2022,000/XXX|May:2022,000/XXX|Apr:2022,000/XXX|Mar:2022,000/XXX|Feb:2022,000/XXX|Jan:2022,000/XXX|Dec:2021,000/XXX|Nov:2021,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "CREDIT-LIMIT": "17,000",
            "CASH-LIMIT": "5,100",
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
            "ACTUAL-PAYMENT": "16,211",
          },
        },
      },
      {
        RESPONSE: {
          "LOAN-DETAILS": {
            "ACCT-NUMBER": "PYTMPPP45381531863029",
            "CREDIT-GUARANTOR": "CLIX CAPITAL SERVICES PVT LTD",
            "ACCT-TYPE": "Consumer Loan",
            "DATE-REPORTED": "31-08-2021",
            "OWNERSHIP-IND": "Individual",
            "ACCOUNT-STATUS": "Closed",
            "DISBURSED-AMT": "7,500",
            "DISBURSED-DT": "25-09-2020",
            "CLOSED-DATE": "05-08-2021",
            "OVERDUE-AMT": "0",
            "WRITE-OFF-AMT": "0",
            "CURRENT-BAL": "0",
            "COMBINED-PAYMENT-HISTORY":
              "Aug:2021,000/XXX|Jul:2021,000/XXX|Jun:2021,000/XXX|May:2021,000/XXX|Apr:2021,000/XXX|Mar:2021,000/XXX|Feb:2021,000/XXX|Jan:2021,000/XXX|Dec:2020,000/XXX|Nov:2020,000/XXX|Oct:2020,000/XXX|Sep:2020,000/XXX|",
            "MATCHED-TYPE": "PRIMARY",
            "LINKED-ACCOUNTS": [],
            "SECURITY-DETAILS": [],
            "REPAYMENT-TENURE": "0",
          },
        },
      },
    ],
    "INQUIRY-HISTORY": [
      {
        HISTORY: {
          "MEMBER-NAME": "LNT FINANCE",
          "INQUIRY-DATE": "30-07-2023",
          PURPOSE: "OTHER",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "15,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "CITRA FINANCIALS PRIVATE LTD",
          "INQUIRY-DATE": "28-07-2023",
          PURPOSE: "OTHER",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,00,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "DEVMUNI LEASING AND FINANCE L",
          "INQUIRY-DATE": "22-06-2023",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,00,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "UPWARDS CAPITAL PVT LTD",
          "INQUIRY-DATE": "12-11-2022",
          PURPOSE: "Other",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "50,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HERO FINCORP LIMITED",
          "INQUIRY-DATE": "04-11-2022",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "40,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "21-09-2022",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "9,00,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "20-09-2022",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "5,70,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "21-07-2022",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "2,00,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "19-07-2022",
          PURPOSE: "Personal Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,50,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "17-05-2022",
          PURPOSE: "Consumer Loan",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "79,900",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "29-11-2021",
          PURPOSE: "Credit Card",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "26-10-2021",
          PURPOSE: "Credit Card",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "12-10-2021",
          PURPOSE: "Credit Card",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,000",
          REMARK: "",
        },
      },
      {
        HISTORY: {
          "MEMBER-NAME": "HDFC BANK LTD",
          "INQUIRY-DATE": "07-09-2021",
          PURPOSE: "Credit Card",
          "OWNERSHIP-TYPE": "PRIMARY",
          AMOUNT: "1,000",
          REMARK: "",
        },
      },
    ],
    SCORES: [
      {
        SCORE: {
          "SCORE-TYPE": "PERFORM CONSUMER 2.0",
          "SCORE-VALUE": "610",
          "SCORE-FACTORS": "SF03|SF15|SF24|SF26|",
        },
      },
    ],
    "PRINTABLE-REPORT": {
      TYPE: "",
      "FILE-NAME": "",
      CONTENT: "",
    },
    "EMPLOYMENT-DETAILS": [
      {
        "EMPLOYMENT-DETAIL": {},
      },
    ],
  },
};

export function getCustomerMonthlyObligation(CRIF_Data) {
  let monthlyObligations = 0;
  if (CRIF_Data) {
    let data = CRIF_Data["B2C-REPORT"].RESPONSES;
    for (let i = 0; i < data.length; i++) {
      let monthlyInstallment =
        data[i].RESPONSE["LOAN-DETAILS"]?.["INSTALLMENT-AMT"];
      if (monthlyInstallment) {
        monthlyInstallment = getNumberFromString(monthlyInstallment);
        monthlyObligations = monthlyObligations + monthlyInstallment;
      }
    }

    return monthlyObligations;
  }
  return monthlyObligations;
}

function getNumberFromString(stringWithNumber) {
  return parseInt(stringWithNumber.replace(/[^0-9]/g, ""));
}

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      alert("please add image/pdf file");
    };
  });
};

export const getBase64Value = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result.split(",")[1]);
    };

    fileReader.onerror = (error) => {
      alert("please add image/pdf file");
    };
  });
};

export function calculateAge2(dob) {
  // Parse the date of birth string into a Date object
  var dobDate = new Date(dob);

  // Get the current date
  var currentDate = new Date();

  // Calculate the difference in milliseconds
  var ageInMilliseconds = currentDate - dobDate;

  // Convert the age from milliseconds to years
  var ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);

  // Round down to the nearest whole number
  var age = Math.floor(ageInYears);

  return age;
}

const calculateImageLuminance = (img) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0);
  const imageData = ctx.getImageData(0, 0, img.width, img.height);
  const data = imageData.data;
  let sum = 0;

  for (let i = 0; i < data.length; i += 4) {
    // Calculate luminance (average of red, green, and blue)
    const luminance = (data[i] + data[i + 1] + data[i + 2]) / 3;
    sum += luminance;
  }

  const averageBrightness = sum / (data.length / 4);
  return averageBrightness;
};

// Function to calculate average brightness of an image
export function validateImageQuality(imageFile) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageFile;

    // Wait for the image to load
    img.onload = function () {
      const averageBrightness = calculateImageLuminance(img);
      resolve(averageBrightness);
    };

    img.onerror = function (error) {
      reject(error); // In case of an error, reject the promise
    };
  });
}




export function removeAllCookies(path) {
  const cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie =
      name +
      `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path ? path : "/"}`;
  }
}
export function isCookieExpired(cookieName) {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${cookieName}=`))
    ?.split("=")[1];

  if (cookieValue) {
    const expirationDate = new Date(cookieValue);
    return expirationDate.getTime() < Date.now();
  }

  return true; // Cookie not found, so it's considered expired
}

export function getCookiePathFromURL(url) {
  var match = url.match(/^https?:\/\/[^\/]+(\/[^\?]+)/);
  if (match) {
    return match[1];
  }
  return null;
}